import React, { Fragment, useEffect, useState } from "react";
import TableForm from "./tableForm";
import { ToastContainer, toast } from "react-toastify";
import "../App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
} from "react-router-dom";
import logo from "./logo/udes.png";

const FormApp6 = ({ reqID, empId, approveEvent }) => {
  const [requestData, setRequestData] = useState([]);
  const [itemsTableData, setItemsTableData] = useState([]);

  const handleRequestSelect = async (reqId) => {
    // get document data

    // get items table

    if (reqId !== null) {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/requests/` + reqId
      );
      const data = await response.json();

      setItemsTableData(data.itemsTableData);
      setRequestData(data.requestData);

      if (requestData.approvedBy1) {
        setApprovedBy1("Approuvé");
      } else {
        setApprovedBy1("Non-apprové");
      }

      if (requestData.approvedBy1) {
        setApprovedBy2("Approuvé");
      } else {
        setApprovedBy2("Non-apprové");
      }

      if (requestData.approvedBy1) {
        setApprovedBy3("Approuvé");
      } else {
        setApprovedBy3("Non-apprové");
      }

      if (requestData.approvedBy1) {
        setApprovedBy4("Approuvé");
      } else {
        setApprovedBy4("Non-apprové");
      }

      if (requestData.approvedBy1) {
        setApprovedBy5("Approuvé");
      } else {
        setApprovedBy5("Non-apprové");
      }
    }
  };

  const updateReqStatus = async (reqId) => {
    if (reqId !== null) {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/requests/` + reqId
      );
      const data = await response.json();

      setItemsTableData(
        data.itemsTableData.sort((a, b) => a.item_num - b.item_num)
      );
      setRequestData(data.requestData);
    }
  };

  const [approvers, setApprovers] = useState([]);
  const fetchAppro = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/approvers`
    );
    const data = await response.json();

    setApprovers(data);
    // console.log(approvers);
  };

  const [docs, setDocs] = useState([]);
  const fetchDocs = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/documents`
    );
    const data = await response.json();

    setDocs(data);
    // console.log(docs);
  };

  // get requests approval records --------------------------------

  const [approvalRecords, setApprovalRecords] = useState([]);
  const fetchApprovalRecords = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/approval_records`
    );
    const data = await response.json();
    setApprovalRecords(data);
  };

  //display the approval status of the document ------------------

  const [approvalRecordsCurrentReq, setApprovalRecordsCurrentReq] = useState(
    []
  );

  function remove_app_id_repetitions(
    orderedApprovalRecords,
    reqID,
    recordsList
  ) {
    const seenAppIds = new Set();

    for (const record of orderedApprovalRecords) {
      if (record.req_id === reqID && !seenAppIds.has(record.app_id)) {
        recordsList.push(record);
        seenAppIds.add(record.app_id);
      }
    }
  }

  const getRecsCurrentReq = () => {
    let recordsList = [];
    let lastRecordsList = [];
    // order approvalRecords by op_time in ascending order

    const orderedApprovalRecords = approvalRecords.sort(
      (a, b) => new Date(b.op_time) - new Date(a.op_time)
    );

    remove_app_id_repetitions(orderedApprovalRecords, reqID, recordsList);

    // lastRecordsList.push(
    //   orderedApprovalRecords[orderedApprovalRecords.length - 1]
    // );

    setApprovalRecordsCurrentReq(recordsList);
  };

  //---------------------------------------------------------------

  const displayApproverTitle = (appId) => {
    for (let i = 0; i < approvers.length; i++) {
      if (approvers[i].app_id == appId) {
        return approvers[i].app_title;
      }
    }
  };

  const getTitlesList = () => {
    let titlesList = [];
    for (let i = 0; i < docs.length; i++) {
      if (docs[i].doc_type_id === requestData.doc_type) {
        titlesList.push(
          displayApproverTitle(requestData.appro_1),
          displayApproverTitle(requestData.appro_2),
          displayApproverTitle(requestData.appro_3),
          displayApproverTitle(requestData.appro_4),
          displayApproverTitle(requestData.appro_5),
          displayApproverTitle(requestData.appro_6),
          displayApproverTitle(requestData.appro_7),
          displayApproverTitle(requestData.appro_8)
        );
      }
    }
    return titlesList.filter((titles) => titles != null);
  };

  const [reqIsApproved, setReqIsApproved] = useState(true);

  const getReqApprovalStatus = () => {
    if (requestData.declined === true) {
      setReqIsApproved(false);
    } else {
      setReqIsApproved(true);
    }
  };

  useEffect(() => {
    getReqApprovalStatus();
  }, [requestData.declined]);

  const approversTitlesList = getTitlesList();

  function ApproDisplay({ approversTitlesList, reqAppRecList }) {
    const numberOfTitles = approversTitlesList.length;

    const layoutClass =
      numberOfTitles <= 1
        ? "appro-disp-single"
        : numberOfTitles === 2
        ? "appro-disp-double"
        : "appro-disp-multiple";

    return (
      <div className={layoutClass}>
        {approversTitlesList.map((title, index) => {
          const filteredRec = reqAppRecList.find(
            (record) => record.app_title === title
          );
          const approverName = filteredRec?.emp_name;

          return (
            <div key={index} className={`appro-disp-${index + 1}`}>
              <p className="appro-title">{title}</p>
              {approverName && (
                <p className="appro-name">Approuvé par Mr. {approverName}</p>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  const [str, setStr] = useState([]);
  // fetch the list of structures from the database, the data includes str_id, str_name, str_parent, str_head
  const fetchStr = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/structures`
    );
    const data = await response.json();

    setStr(data);
  };

  function getStrName(str, assignedStr) {
    // Find object in strData that matches assigned_str
    const strTitle = str.find((obj) => obj.str_id === assignedStr);

    // Return str_name if match found, otherwise return empty string
    return strTitle ? strTitle.str_name : "";
  }

  const [totalPrice, setTotalPrice] = useState(0);
  const calculateTotalPrice = () => {
    let total = 0;
    for (let i = 0; i < itemsTableData.length; i++) {
      if (
        itemsTableData[i].unit_price !== null &&
        itemsTableData[i].quantity !== null
      ) {
        total += itemsTableData[i].unit_price * itemsTableData[i].item_qt;
      }
    }
    setTotalPrice(total);
  };

  useEffect(() => {
    calculateTotalPrice();
  }, [itemsTableData]);

  useEffect(() => {
    fetchApprovalRecords();
    getRecsCurrentReq();
  }, [approvalRecords.length, reqID, approveEvent]);

  useEffect(() => {
    updateReqStatus(reqID);
  }, [approveEvent, reqID]);

  useEffect(() => {
    handleRequestSelect(reqID);
    fetchDocs();
    fetchAppro();
    fetchStr();
  }, []);

  useEffect(() => {
    handleRequestSelect(reqID);
  }, [reqID]);

  const [approvedBy1, setApprovedBy1] = useState(null);
  const [approvedBy2, setApprovedBy2] = useState(null);
  const [approvedBy3, setApprovedBy3] = useState(null);
  const [approvedBy4, setApprovedBy4] = useState(null);
  const [approvedBy5, setApprovedBy5] = useState(null);

  return (
    <div className="document-page">
      <div className="doc-heading">
        <div className="doc-heading-top">
          <div className="doc-ht-ar">
            الجمهورية الجزائرية الديمقراطية الشعبية
          </div>
          <div className="doc-ht-fr">
            République Algérienne Démocratique et Populaire
          </div>
          <div className="doc-ht-ar">وزارة التعليم العالي و البحث العلمي</div>
          <div className="doc-ht-fr">
            Ministère de l'Enseignement Supérieur et de la Recherche
            Scientifique
          </div>
        </div>
        <div className="doc-heading-line"></div>
        <div className="doc-heading-bottom">
          <div className="doc-hb-left">
            <span className="doc-hb-uplef-text">EPST/CDER</span>
            <span className="doc-hb-bottlef-text">
              UNITE DE DEVELOPEMENT DES EQUIPEMENTS SOLAIRES
            </span>
          </div>
          <div className="doc-heading-logo">
            <img src={logo} alt="logo" />
          </div>

          <div className="doc-hb-right">
            <span className="doc-hb-upright-text">م.ع.ط.ع.ت./م.ط.ت.م</span>
            <span className="doc-hb-bottright-text">
              وحدة تنمية الاجهزة الشمسية
            </span>
          </div>
        </div>
        <div className="doc-heading-line"></div>
      </div>

      <div className="doc-body-top">
        <div className="doc-top-info">
          <span className="label">N°:</span>
          <span className="value">REF-R-2023{requestData.ref_field}</span>
        </div>
        <div className="doc-top-info">
          <span className="label">Bou-ismail, le:</span>
          <span className="value">
            {new Date(requestData.req_date).toLocaleDateString("en-GB")}
          </span>
        </div>
      </div>

      <div className="doc-body-middle">
        <div className="doc-body-title">
          <h5>DEMANDE D'APPROVISIONNEMENT HORS PROJET DE RECHERCHE</h5>
        </div>
        <div className="doc-body-mid-info">
          <div className="info">
            <span className="">Intitulé du Projet de recherche:</span>
            <span className="value">{requestData.project}</span>
          </div>

          <div className="info">
            <span className="">Responsable de projet:</span>
            <span className="value">{requestData.project_head}</span>
          </div>
          <div className="info">
            <span className="">Equipe/Division:</span>
            <span className="value">
              {getStrName(str, requestData.issuing_str)}
            </span>
          </div>

          <div className="info">
            <span className="">
              Réf. de la demande de travaux (le cas échéant):
            </span>
            <span className="value">{requestData.ref_work_request}</span>
          </div>
        </div>

        <table className="doc-table table ">
          <thead className="table-head">
            <tr>
              <th className="align-top">N°</th>
              <th className="align-top">
                Désignation des fournitures ou travaux
              </th>
              <th className="align-top">Quantité</th>
              <th className="align-top">Prix Unitaire</th>
              <th className="obsrv">Observation:</th>
            </tr>
          </thead>
          <tbody>
            {itemsTableData.map((request) => (
              <tr key={request.req_id}>
                <td>{request.item_num}</td>
                <td>{request.item_description}</td>

                <td>{request.item_qt}</td>
                <td>{request.unit_price}</td>
                <td>{request.item_observation}</td>
              </tr>
            ))}
            <tr>
              <td style={{ textAlign: "right" }} colSpan="2">
                Total:
              </td>
              <td colSpan="2">{totalPrice}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="doc-body-bottom">
        <div id="doc-approvers" className="doc-approvers">
          <ApproDisplay
            approversTitlesList={approversTitlesList}
            reqAppRecList={approvalRecordsCurrentReq}
          />
        </div>
      </div>

      <div className="doc-footer">
        <div className="doc-footer-separator"></div>
        <span className="doc-footer-text">
          UDES, Route Nationale N°11, BP386, Bou-Ismail, 42415, Wilaya de Tipaza
          Tel. / Fax : 024221408, Site Web :udes.cder.dz
        </span>
      </div>
    </div>
  );
};

export default FormApp6;
